import { Dialog } from "@dash/dialog";
import { Button, TextField } from "@dash/form";
import { useDeviceType } from "@dash/mq";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";
import { useClientManager } from "@megaron/react-clients";
import { newUuid } from "@megaron/uuid";

export const AddReportDialog: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { isMobile } = useDeviceType();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState<string | null>(null);

  const save = useClientManager("crm")
    .saveReport()
    .useMutation({
      onSuccess: async (report, _, { queryClient }) => {
        await queryClient.invalidateQueries(["crm", "reportsQuery"]);
        navigate(getMegaraxPath.uri("megarax://crm/reports/id/{id}", { id: report.uuid }));
      },
    });

  const submit = () => {
    if (!title.trim()) return setError("Podaj nazwę raportu");
    save.mutate({ uuid: newUuid(), title: title.trim(), description: description.trim(), cells: [] });
  };

  return (
    <Dialog
      onClose={onClose}
      header="Nowy raport"
      placement={isMobile ? "top" : "center"}
      css={{ width: "500px", height: "auto" }}
    >
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "2px" }}>
        <TextField
          label="Nazwa"
          value={title}
          onChange={(value) => {
            setTitle(value);
            setError(null);
          }}
          error={error}
          autoFocus
        />
        <TextField label="Opis" value={description} onChange={setDescription} multiline />
        <Button css={{ alignSelf: "flex-end" }} onClick={submit} isLoading={save.isLoading}>
          Utwórz
        </Button>
      </div>
    </Dialog>
  );
};
